import { useEffect, useRef, useState } from 'react'
import { Dropdown, type DropdownProps } from 'primereact/dropdown'

/**
 * `Dropdown` + mobil "sheet" backdrop'ı TEK yerde: `panelClassName="ui-mobile-sheet"` ile alttan açılan
 * panelin karartması/dış-tıklamayla kapatması/kaydırma kilidi artık burada yaşar — çağıran normal
 * `Dropdown` prop'larını verir, ref/`onShow`/`onHide`/backdrop kablolamasıyla uğraşmaz.
 *
 * <p><b>Karartma GERÇEK bir ögedir</b> (CSS `:has()` denemesi TERK EDİLDİ — kullanıcı bildirimi
 * 2026-08-29: "sayfa bazen kilitleniyor, kaydıramıyorum"): `body:has(.p-dropdown-panel.ui-mobile-sheet)`
 * panel görünür bir şekilde kapandıktan SONRA bile DOM'da (gizli/boş) kalabiliyordu ve seçici sonsuza dek
 * eşleşmeye devam edip `overflow: hidden`'ı sayfada asılı bırakıyordu. Gerçek bir öge + gerçek `onShow`/
 * `onHide` durumu, panelin DOM ömrüyle DEĞİL, PrimeReact'in kendi "açık/kapalı" olayıyla eşleşir — asla
 * yanlışlıkla asılı kalmaz. Kaydırma kilidi de aynı gerekçeyle React `useEffect` temizliğine bağlıdır:
 * bileşen unmount olsa bile React kilidi garanti kaldırır.
 *
 * <p>Dropdown kullanan TÜM `ui-mobile-sheet` seçiciler bu bileşene taşındı (ActionsListPanel'in Sorumlu
 * filtresi, StakeholdersDialog'un prensip kararı seçici). AutoComplete tabanlı kişi seçiciler (bkz.
 * `ActionPeopleEditor`/`SinglePersonEditor`) aynı deseni izleyen ayrı bir bileşen kullanır:
 * `MobileSheetAutoComplete`.
 *
 * <p><b>`open` durumu `onClick`'te ANINDA güncellenir</b> (yalnız `onShow`/`onHide`'a değil) — bunlar
 * panelin geçiş animasyonu BİTTİKTEN sonra tetiklenir ve karartma gözle görülür gecikmeyle belirirdi
 * (kullanıcı bildirimi 2026-08-29).
 */
export default function MobileSheetDropdown(props: Readonly<DropdownProps>) {
  const ref = useRef<Dropdown>(null)
  const [open, setOpen] = useState(false)
  const { panelClassName, onShow, onHide, onClick, ...rest } = props

  useEffect(() => {
    if (!open) return
    document.body.classList.add('ui-mobile-sheet-lock')
    return () => document.body.classList.remove('ui-mobile-sheet-lock')
  }, [open])

  return (
    <>
      <Dropdown
        {...rest}
        ref={ref}
        panelClassName={panelClassName ? `${panelClassName} ui-mobile-sheet` : 'ui-mobile-sheet'}
        // PrimeReact'in `onShow`/`onHide`'ı panel geçiş ANİMASYONU BİTTİKTEN sonra tetiklenir (bkz.
        // dropdown.esm.js `onOverlayEntered`) — karartma ona bağlıyken alttan açılan panelden gözle
        // görülür bir gecikmeyle beliriyordu (kullanıcı bildirimi 2026-08-29). Tetikleyiciye tıklanır
        // tıklanmaz (animasyon başlamadan) karartmayı burada anında göstererek/gizleyerek düzeltilir;
        // "X" (Temizle) simgesine tıklama PrimeReact'te paneli AÇIP KAPATMAZ, o yüzden burada da atlanır.
        onClick={(e) => {
          const target = e.target as HTMLElement
          if (!target.closest?.('.p-dropdown-clear-icon')) setOpen((prev) => !prev)
          onClick?.(e)
        }}
        onShow={() => {
          setOpen(true)
          onShow?.()
        }}
        onHide={() => {
          setOpen(false)
          onHide?.()
        }}
      />
      {open && (
        <div
          className="ui-mobile-sheet-backdrop"
          onClick={() => {
            setOpen(false)
            ref.current?.hide()
          }}
          aria-hidden="true"
        />
      )}
    </>
  )
}

